import { useState } from 'react'
import { BsChevronDown } from 'react-icons/bs'
import './Work.css'

const timelineItems = [
  {
    title: 'Bachelors at UC Irvine',
    cardTitle: 'BSc Computer Science and BSc Informatics',
    roleTone: 'academic',
    cardSubtitle: 'Sep 2018 - Dec 2022',
    cardDetailedText:
      'I completed a double bachelor’s degree in Computer Science and Informatics at the University of California, Irvine, with specializations in Intelligent Systems and Organizations & Information Technology. As a consistent Dean’s Honors List recipient from 2018 to 2022, I built a strong academic foundation across both technical and human-centered disciplines. My coursework included Data Structures and Algorithms, Software Life Cycle Models, Machine Learning and Data Mining, Web Crawling, and User Interface Priciples.\n',
  },
  {
    title: 'Interning at Chegg',
    cardTitle: 'Software Engineer Intern',
    roleTone: 'intern',
    cardSubtitle: 'Jun 2021 - Sep 2021',
    cardDetailedText:
      'At Chegg, I developed production-level Python scripts to process Amazon SQS messages and SQL query results into SQL databases, and integrated Redis caching into key data-handling services. I also initiated the migration of backend services to a new proprietary event-handling system. Alongside our QA team, I worked to identify and fix product issues.\n',
  },
  {
    title: 'Interning at MLB',
    cardTitle: 'Software Engineer Intern',
    roleTone: 'intern',
    cardSubtitle: 'Jul 2022 - Oct 2022',
    cardDetailedText:
      'As a Software Engineering Intern at Major League Baseball, working with their Tickets.com subsidiary, I developed full pages and reusable components for the MLB ticket-purchasing platform, ensuring they met user requirements and adhered to accessibility standards. I contributed to code quality initiatives by helping establish coding standards and promoting scalable architectural patterns. Additionally, I refactored parts of the codebase to integrate modern libraries and updated data providers, improving maintainability and performance.\n',
  },
  {
    title: 'Full-Time Associate',
    cardTitle: 'Associate Software Engineer',
    roleTone: 'engineering',
    cardSubtitle: 'Nov 2022 - Mar 2024',
    cardDetailedText:
      'Continuing in a full-time role as an Associate Software Engineer at MLB, I led key payment-related initiatives for season ticket package renewals, including the development of personal credit card management features, validation flows, and PCI-compliant tokenization. I architected and implemented several MLB team–specific features, such as enhanced site analytics and customizable styling to align with individual team branding. To support legal requirements, I integrated electronic signature capabilities into the platform. In addition to development, I served as an on-call resource, providing technical support and ensuring the reliability of critical services.\n',
  },
  {
    title: 'Promotion to Mid-Level',
    cardTitle: 'Software Engineer',
    roleTone: 'engineering',
    cardSubtitle: 'Mar 2024 - Apr 2025',
    cardDetailedText:
      'As a mid-level Software Engineer at MLB, I led the development of a split payments feature, enabling customers to split large-cost season ticket renewals across multiple cards. I also spearheaded the planning and integration of Zip, a third-party Buy Now, Pay Later service, expanding payment flexibility for ticket buyers. In support of a broader platform modernization effort, I developed reusable React components for a new “Guest Checkout” flow, allowing users to complete transactions without logging in, hence, streamlining the purchase experience for casual fans.\n',
  },

  {
    title: 'Return to UCI for Masters',
    cardTitle: 'Master of Data Science',
    roleTone: 'academic',
    cardSubtitle: 'Sep 2024 - Dec 2025',
    cardDetailedText:
      'I completed a Master of Data Science (M.D.S.) degree at the University of California, Irvine, focusing on advanced analytical and computational methods for working with data. My coursework includes Artificial Intelligence and Machine Learning, Probability and Statistical Theory, Advanced Data Structures and Algorithms, Linear Regression Modeling, and Graphical and Generative Modeling.\n',
  },

  {
    title: 'Joining CHRP.ai',
    cardTitle: 'Software Engineer',
    roleTone: 'engineering',
    cardSubtitle: 'Oct 2025 - Present',
    cardDetailedText:
      'At CHRP.ai, a platform focused on using music to support personal growth and goal achievement, I built core product systems including a user feedback pipeline and integrations with Spotify and Amazon Music. I also developed a personalized music recommendation engine that leverages listening behavior to deliver goal-driven song recommendations.\n',
  },
]

const timelineIcons = [
  'anteater.png',
  'chegg.jpg',
  'mlb_logo.png',
  'mlb_logo.png',
  'mlb_logo.png',
  'anteater.png',
  'chrp.png',
]

function Work() {
  const [activeIndex, setActiveIndex] = useState(0)
  const items = [...timelineItems].reverse()
  const icons = [...timelineIcons].reverse()

  return (
    <div className="work">
      <div className="timeline">
        {items.map((item, index) => {
          const isActive = activeIndex === index
          const detailId = `timeline-detail-${index}`

          return (
            <article
              key={item.title}
              className={`timeline-item ${isActive ? 'active' : ''}`}
            >
              <div className="timeline-marker">
                <span className="timeline-dot" />
                {index < items.length - 1 && <span className="timeline-line" />}
              </div>
              <button
                type="button"
                className="timeline-card"
                onClick={() => setActiveIndex(index)}
                aria-expanded={isActive}
                aria-controls={detailId}
                aria-label={`${item.title}. ${item.cardTitle}. ${
                  isActive ? 'Experience details expanded.' : 'Activate to expand experience details.'
                }`}
              >
                <div className="timeline-header">
                  <div className="timeline-heading">
                    <img
                      src={icons[index]}
                      alt={`${item.title} logo`}
                      className="timeline-icon"
                    />
                    <h3>{item.title}</h3>
                  </div>
                  <span className="timeline-dates">{item.cardSubtitle}</span>
                </div>
                <div className="timeline-card-summary">
                  <h4 className={`timeline-role timeline-role-${item.roleTone}`}>
                    {item.cardTitle}
                  </h4>
                  {!isActive && (
                    <span className="timeline-card-affordance" aria-hidden="true">
                      <BsChevronDown
                        className="timeline-expand-icon"
                        aria-hidden="true"
                      />
                    </span>
                  )}
                </div>
                <p className="timeline-text" id={detailId}>
                  {item.cardDetailedText}
                </p>
              </button>
            </article>
          )
        })}
      </div>
    </div>
  )
}
export default Work
